<div style="display: flex; flex-direction: row; ">
    <dx-autocomplete
        placeholder="Search for client by name, first address line, postcode, email address, mobile phone number or client number"
        style="flex-grow: 1;" noDataText="No search results" (onKeyUp)="onKeyUp($event)" [dataSource]="results"
        maxItemCount="10" searchTimeout="20" [showClearButton]="true" minSearchLength="1" searchEnabled="true"
        valueExpr="Description" searchMode="contains" (onItemClick)="onItemClick($event)"
        searchExpr="['FirstName', 'LastName','ClientNumber','MobileTelephone','EmailAddress','Address','Postcode"
        [inputAttr]="{ id: 'elClientFinderInput' }" itemTemplate="full">
        <div *dxTemplate="let c of 'full'" style="display: flex; flex-direction: row;">
            <div>
                {{c.FirstName}} {{c.LastName}}
            </div>
            <div *ngIf="c.ClientNumber" style="padding-left: 10px;">
                ({{c.ClientNumber}})
            </div>
            <div *ngIf="c.MobileTelephone" style="padding-left: 10px;">
                [{{c.MobileTelephone}}]
            </div>
            <div style="padding-left: 10px;">
                {{c.EmailAddress}}
            </div>
            <div style="padding-left: 10px;">
                {{c.AddressLine1}}, {{c.PostCode}}
            </div>
        </div>
    </dx-autocomplete>
    <dx-button icon="add" (onClick)="btnNewClient($event)" style="margin-right: 5px; margin-left: 5px;"
        hint='Add a new client' [visible]="showNewClientButton">
    </dx-button>
    <dx-load-indicator [visible]="showLoadingIndicator"></dx-load-indicator>
    <app-client-editor (CloseDlg)="CloseDlg($event)">
    </app-client-editor>
</div>